import gql from "graphql-tag";
import { getHeaders } from "application/functions";
import apolloGetMutation from "application/apollo/apolloGetMutation";

const createAnswer = (content) =>
  apolloGetMutation(
    {
      mutation: gql`
        mutation createContent($content: ContentInput!) {
          content(content: $content) {
            id
          }
        }
      `,
      variables: content,
    },
    getHeaders()
  );

export default {
  createAnswer,
};
